import styled from "styled-components";
import colours from "styles/colours";

export const ButtonsDiv = styled.div`
  display: flex;
  margin: 2.25rem 0 1.13rem;

  button:not(:first-child) {
    margin-left: 1.5rem;
  }
`;

export const UnsavedChangesDiv = styled.div`
  color: ${colours.elexonBlue};
`;

export const ErrorMessageDiv = styled.div`
  color: ${colours.elexonRed};
`;
